import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Admin.css';

function AdminDashboard({ onLogout }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    onLogout();
    navigate('/admin/login');
  };

  if (loading) {
    return <div className="loading-container"><div className="loading-spinner"></div></div>;
  }

  return (
    <div className="admin-page" data-testid="admin-dashboard">
      <nav className="admin-nav">
        <div className="admin-nav-content">
          <h1 className="brand-text">ClutchBabe9 Admin</h1>
          <div className="admin-nav-links">
            <Link to="/admin/dashboard" className="admin-nav-link active">Dashboard</Link>
            <Link to="/admin/posts" className="admin-nav-link">Posts</Link>
            <Link to="/admin/videos" className="admin-nav-link">Videos</Link>
            <Link to="/admin/subscribers" className="admin-nav-link">Subscribers</Link>
            <Link to="/admin/contacts" className="admin-nav-link">Contacts</Link>
            <Link to="/admin/profile" className="admin-nav-link">Profile</Link>
            <Link to="/admin/config" className="admin-nav-link">Settings</Link>
            <Link to="/" className="admin-nav-link view-site-link" data-testid="view-site-btn">🌐 View Site</Link>
            <button onClick={handleLogout} className="btn btn-ghost">Logout</button>
          </div>
        </div>
      </nav>

      <div className="admin-content">
        <h2>Dashboard Overview</h2>
        
        <div className="stats-grid">
          <div className="stat-card glass-card">
            <div className="stat-value">{stats?.total_posts || 0}</div>
            <div className="stat-label">Total Posts</div>
          </div>
          <div className="stat-card glass-card">
            <div className="stat-value">{stats?.total_subscribers || 0}</div>
            <div className="stat-label">Subscribers</div>
          </div>
          <div className="stat-card glass-card">
            <div className="stat-value">{stats?.total_contacts || 0}</div>
            <div className="stat-label">Contact Messages</div>
          </div>
        </div>

        <div className="recent-section">
          <h3>Recent Posts</h3>
          {stats?.recent_posts && stats.recent_posts.length > 0 ? (
            <div className="recent-posts-list">
              {stats.recent_posts.map(post => (
                <div key={post._id} className="recent-post-item glass-card">
                  <h4>{post.title}</h4>
                  <p>{post.category} • {new Date(post.publish_date).toLocaleDateString()}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state glass-card">
              <p>📝 No posts yet. Create your first gaming blog post!</p>
              <Link to="/admin/posts/new" className="btn btn-primary">Create New Post</Link>
            </div>
          )}
        </div>

        <div className="quick-actions">
          <Link to="/admin/posts/new" className="btn btn-primary">Create New Post</Link>
          <Link to="/admin/posts" className="btn btn-secondary">Manage Posts</Link>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
